import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=0407b0be&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=0407b0be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0407b0be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0407b0be')) {
      api.createRecord('0407b0be', component.options)
    } else {
      api.reload('0407b0be', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=0407b0be&scoped=true&", function () {
      api.rerender('0407b0be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2dRpfmJccradH/JS/comp/PopupBox.vue"
export default component.exports